<!--品与服务-平台产品产-->
<template class="home">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="prod"  :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div>
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in carouselList' :key='item.id'>
            <div>
              <el-image
                style="width: 100%;height: 25vw"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--产品介绍标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{cnNameOne}}
          </h1>
          <p>{{enNameOne}}</p>
        </div>
      </div>
      <!--产品介绍-->
      <el-row :span="24" class="box-width carbon background_img">
        <el-col :md="12" :sm="12" :xs="24">
          <div class="div_img">
            <el-image class="carbon_img" :src="productIntroduction.img"></el-image>
          </div>
        </el-col>
        <el-col :md="12" :sm="12" :xs="24">
          <div class="text">
            <h4>{{ productIntroduction.title }}</h4>
            <div v-html="productIntroduction.content" class="htmlImgSize">
            </div>
          </div>
        </el-col>
      </el-row>

      <!--产品功能标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameTwo }}
          </h1>
          <p>{{ enNameTwo }}</p>
        </div>
      </div>
      <!--产品功能-->
      <el-row  :gutter="20" class="box-width Product">
        <el-col v-for="(item, index) in productFeatures" :key="index" :lg="8" :md="8" :sm="12" :xs="24">
          <el-card shadow="hover" :body-style="{ padding: '0px' }" class="card_box">
            <el-image
              alt="Image Description"
              :src="item.img"
              :fit="fit">
            </el-image>
            <div class="text">
              <h4>{{ item.title }}</h4>
              <i><div v-html="item.content" class="htmlImgSize"></div></i>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!--典型应用标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameThree }}
          </h1>
          <p>{{ enNameThree }}</p>
        </div>
      </div>
      <!--典型应用-->
      <div class="b_img" :style="bgStyle">
        <div class="box-width">
          <el-row :gutter="20" class="application">
            <el-col :md="12" :sm="12" :xs="24">
              <el-carousel height="340px">
                <el-carousel-item v-for="(item, index) in typicalApplications.imgs" :key="index">
                  <el-image
                    alt="Image Description"
                    :src="item"></el-image>
                </el-carousel-item>
              </el-carousel>
            </el-col>
            <el-col :md="12" :sm="12" :xs="24">
              <div class="app_text">
                <h3>{{typicalApplications.title}}</h3>
                <h5>{{ typicalApplications.subtitle }}</h5>
                <div v-html="typicalApplications.content" class="htmlImgSize"></div>
              </div>
            </el-col>
          </el-row>

        </div>
      </div>

      <!--产品优势标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameFour }}
          </h1>
          <p>{{ enNameFour }}</p>
        </div>
      </div>
      <!--产品优势-->
      <el-row :span="24" class="box-width carbon">
        <el-col :md="12" :sm="12" :xs="24">
          <div class="advantage_img">
            <el-image
              alt="Image Description"
              :src="productAdvantages.img"
              :fit="fit"></el-image>
          </div>
        </el-col>
        <el-col :md="12" :sm="12" :xs="24">
          <div v-html="productAdvantages.content" class="htmlImgSize"></div>
        </el-col>
      </el-row>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel height="200px" class='carousel_class'>
            <el-carousel-item v-for='item in carouselList' :key='item.id'>
              <div>
                <el-image
                  :fit='fit'
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--产品介绍-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameOne }}
                <span>{{ enNameOne }}</span>
              </h1>
            </div>
            <!--图片-->
            <div class="product_img">
              <el-image :src="productIntroduction.img"></el-image>
            </div>
            <!--内容-->
            <div>
              <h6> <i class="el-icon-position"></i>
                {{ productIntroduction.title }}
              </h6>
              <div v-html="productIntroduction.content" class="htmlImgSize"></div>
            </div>
          </div>
        </div>

        <!--产品功能-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameTwo }}
                <span>{{ enNameTwo }}</span>
              </h1>
            </div>
            <!--内容-->
            <div v-for="(item, index) in productFeatures" :key="index">
              <h6>
                <i class="el-icon-position"></i>
                {{ item.title }}
              </h6>
              <div v-html="item.content" class="htmlImgSize"></div>
            </div>
          </div>
        </div>

        <!--典型应用-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameThree }}
                <span>{{ enNameThree }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <h3 style="text-align: center">{{typicalApplications.title}}</h3>
<!--              <h5 style="text-align: left;font-weight: normal">{{ typicalApplications.subtitle }}</h5>-->
              <div v-html="typicalApplications.content" class="htmlImgSize"></div>
            </div>
          </div>
        </div>

        <!--产品优势-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameFour }}
                <span>{{ enNameFour }}</span>
              </h1>
            </div>
            <!--图片-->
            <div class="product_img">
              <el-image style="width: 100%"  :src="productAdvantages.img"></el-image>
            </div>
            <!--内容-->
            <div>
              <h6>
                {{ productAdvantages.title }}
              </h6>
              <div v-html="productAdvantages.content" class="htmlImgSize"></div>
            </div>
          </div>
        </div>

        <!--提交需求-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                提交需求
                <span>Submit Requirements</span>
              </h1>
            </div>
            <!--form表单-->
            <el-form class="el_form" :model="form" ref="consultRef" :rules="rules">
              <el-form-item prop="unitName">
                <el-input class="consult_inp" placeholder="单位" v-model="form.unitName"></el-input>
              </el-form-item>
              <el-form-item prop="fullName">
                <el-input class="consult_inp" placeholder="姓名" v-model="form.fullName"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input class="consult_inp" placeholder="电话" v-model="form.phone"></el-input>
              </el-form-item>
              <el-form-item prop="demand">
                <el-input class="consult_inp" placeholder="需求" type="textarea" v-model="form.demand"></el-input>
              </el-form-item>
              <el-button size="small" type="primary" @click="onSubmit">提 交</el-button>
            </el-form>
          </div>
        </div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { findBanner, findEnName, findProductsServicesOne, findProductsServicesTwo, findProductsServicesThree, findProductsServicesFour, addDemand } from '@/api/zh'

export default {
  data () {
    return {
      backgroundImageUrl: require('../../assets/images/index/gz.jpg'),
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      form: {
        unitName: '',
        fullName: '',
        phone: '',
        demand: ''
      },
      activeName: 'second',
      fit: 'cover',
      src: require('@assets/images/index/kjtb.png'),
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png'),
      carouselList: [],
      carouselParams: {
        type: 1
      },
      enNameOne: '',
      enNameTwo: '',
      enNameThree: '',
      enNameFour: '',
      cnNameOne: '',
      cnNameTwo: '',
      cnNameThree: '',
      cnNameFour: '',
      productIntroduction: {
        img: '',
        title: '',
        content: ''
      },
      productFeatures: [],
      typicalApplications: {
        imgs: [],
        title: '',
        content: '',
        subtitle: ''
      },
      productAdvantages: {
        img: '',
        title: '',
        content: ''
      },
      rules: {
        unitName: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        demand: [{ required: true, message: '请输入需求', trigger: 'blur' }]
      }
    }
  },
  computed: {
    bgStyle () {
      return {
        backgroundImage: `url(` + this.backgroundImageUrl + `)`
      }
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.selectEnName()
  },
  mounted () {
  },
  methods: {
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.carouselList = res.data
      })
    },
    /** 查询英文名称 */
    selectEnName () {
      let that = this
      findEnName(this.tabId).then(res => {
        let data = res.data
        that.enNameOne = data[0].enName
        that.cnNameOne = data[0].cnName
        that.selectProductsServicesOne(data[0].id)

        that.enNameTwo = data[1].enName
        that.cnNameTwo = data[1].cnName
        that.selectProductsServicesTwo(data[1].id)

        that.enNameThree = data[2].enName
        that.cnNameThree = data[2].cnName
        that.selectProductsServicesThree(data[2].id)

        that.enNameFour = data[3].enName
        that.cnNameFour = data[3].cnName
        that.selectProductsServicesFour(data[3].id)
      }).catch(error => {
        console.error('Error fetching English names:', error)
      })
    },
    selectProductsServicesOne (enNameId) {
      let that = this
      findProductsServicesOne(enNameId).then(res => {
        that.productIntroduction.img = res.data.fullPathUrl
        that.productIntroduction.title = res.data.title
        that.productIntroduction.content = res.data.piContent
      })
    },
    selectProductsServicesTwo (enNameId) {
      let that = this
      findProductsServicesTwo(enNameId).then(res => {
        res.data.forEach(item => {
          let pf = {}
          pf.img = item.fullPathUrl
          pf.title = item.title
          pf.content = item.content
          that.productFeatures.push(pf)
        })
      })
    },
    selectProductsServicesThree (enNameId) {
      let that = this
      findProductsServicesThree(enNameId).then(res => {
        res.data.imgs.forEach(item => {
          that.typicalApplications.imgs.push(item.fullPathUrl)
        })
        that.backgroundImageUrl = res.data.fullPathUrl
        that.typicalApplications.title = res.data.title
        that.typicalApplications.subtitle = res.data.subtitle
        that.typicalApplications.content = res.data.content
      })
    },
    selectProductsServicesFour (enNameId) {
      let that = this
      findProductsServicesFour(enNameId).then(res => {
        that.productAdvantages.img = res.data.fullPathUrl
        that.productAdvantages.content = res.data.piContent
      })
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    },
    onSubmit () {
      let that = this
      this.$refs.consultRef.validate((valid) => {
        if (valid) {
          let params = that.form
          params.tabId = that.tabId
          addDemand(params).then(res => {
            that.$message({
              type: 'success',
              message: res.msg,
              duration: 1000
            })
            that.form = {}
          }).catch(error => {
            console.log('Error submitting form:', error)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .htmlImgSize img{
  max-width: 100%;
  height: auto;
}
</style>
